export abstract class SettingsPage {
  abstract save();

  disabled = true;
  loading = false;
}
